export default __webpack_public_path__ + "static/media/campaigns_unselected.44c43d25.svg";